<template functional>
    <router-link :to="props.href" :active-class="props.activeClass" :exact-active-class="props.exactActiveClass" :exact="props.href == '/'">
        <slot></slot>
    </router-link>
</template>
<script>
export default {
    props: ['href', 'activeClass', 'exactActiveClass'],
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/common/LinkElements/RouterLink.vue